import React, { useState, useContext,useEffect } from "react";

import Layout from "../../Components/Layout";
import MainMenu from "../../Components/MainMenu";
// import Card from '../../Components/ListPageCard/Card'
import AngelCard from "../../Components/ListPageCard/AngelCard";
import Table from "../../Components/AllTableComponent";
// import { PE_TABLE_QUERY } from '../../Queries/Pe';

import MonthPickerComponent from "../../Utils/MonthPickerComponent";
import xls from "../../images/xls/png/Group 47.png";
import FileIcon from "../../images/file.png";
import FileIconBlur from "../../images/fileblur.png";
// import ExcelPopup from "../../Components/ExcelPopup";
import line from "../../images/line.png";
import moment from "moment";

import RefineSearch from "../../Components/RefineSearchComponent";
import FilterTag from "../../Components/Tag";
// import chatPopupIcon from '../../images/chatPopupIcon.png'
// import ChatPopup from '../../Components/ChatPopup'
import ExportPopup from "../../Components/ExportPopup";
import { angelInvestmentExportData } from "../../Components/ExportPopup/ExportData";

import SavedFilterContent from "../../Components/SavedFilter";
import SavedFilterICON from "../../Components/SavedFilter/SavedFilterICON";

import { exportPDF } from "../../Config/config";
import Constants from "../../Constants";
import AngelRefineSearch from "../../Components/RefineSearch/AngelRefineSearch";
import { useLocation } from "react-router";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { UserContext } from "../../Contexts/UserContext";
import { Switch, Tooltip } from "antd";
import ExcelDownloader from "../../Components/shared/ExcelDownloader";
import { TableDataContext } from "../../Contexts/TableDataContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../../Components/ExportPopup/DownloadTrigger";

/**
 * The function `AngelInvestment` is a JavaScript function that renders a page for displaying angel
 * investments.
 * @returns The function `AngelInvestment` returns JSX elements that make up the UI for the Angel
 * Investment page.
 */
function AngelInvestment() {
  //  const [save, setSave] = useState(false);
  const { save, setSave, showMonthPicker, isMobile,setOpen,open,setIsMobile } = useContext(PeFilterContext);
  const [showPopup, setShowPopup] = useState(false);
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ]);
  const savedList = () => {
    setSave(!save);
  };
  useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }    },[])

  const location = useLocation();
  const { pathname } = useLocation();
  const { isStudent, isDirectoryUser, isTrialExport } = useContext(UserContext);
  const {
    refineSearchFilters,
    groupId,
    dealsView,
    setDealsView,
    switchValue,
    setSwitchValue,
  } = useContext(PeFilterContext);
  const { globalSearchResult } = useContext(TableDataContext);
  const isFromGlobalSearch = () =>
    refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false;

  const dealsViewHandler = (checked) => {
    setSwitchValue(checked);
    if (checked) {
      setDealsView(true);
    } else setDealsView(false);
  };

  return (
    <Layout>
      <div className="flex h-screen flex-col">

        {/* Bottom section */}
        <div className="flex min-h-0 flex-1">
          {/* Narrow sidebar*/}
          {/* Main area */}
          <main
            className={
              isFromGlobalSearch()
                ? "min-w-0 flex-1 border-t border-gray-200 flex"
                : "min-w-0 flex-1 border-t mt-12 border-gray-200 flex"
            }
          >
            {/* Primary column */}
            <section className="flex h-full min-w-0 flex-1 overflow-y-auto flex-col lg:order-last">
              {/* Your content */}
              <div className="mr-[4.25rem] flex justify-between lg:items-center xl:items-center  md:items-center items-baseline">
                <div></div>
                <ToggleDealsViewButton />
                </div>
              <div className="pl-3 pr-4 md:pr-5">
                <div className="scrollbar  rounded shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                  <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between  ">
                                    <div></div>

                      <div
                        className={
                          "md:flex justify-between items-center px-2 py-2 space-x-4 " +
                          (showMonthPicker != 0 ? "" : "flex")
                        }
                      >
                        <label htmlFor="" className="text-[#666666] ">
                                          <div></div>

                        </label>
                        <div
                          className={
                            showMonthPicker != 0
                              ? "hidden md:flex space-x-3"
                              : "flex space-x-3"
                          }
                        >
                      
                          {isStudent == "true" ? (
                            <></>
                          ) : (
                            <>
                              <button>
                                {isTrialExport == "false" ? (
                                  <ExcelDownloader
                                    url={exportPDF}
                                    fileName={
                                      Constants.exportNames.pe_company_angel
                                    }
                                    data={{ type: "angel" }}
                                    children={
                                        <DownloadTrigger />
                                    }
                                  />
                                ) : (
                                  <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                                )}
                                {showPopup && (
                                  <ExportPopup
                                    onClose={() => setShowPopup(false)}
                                    modules="company"
                                    url={exportPDF}
                                    module_type="pe"
                                    fileName={
                                      Constants.exportNames.pe_company_angel
                                    }
                                    exportOptions={angelInvestmentExportData}
                                    type="angel"
                                    with_deals="false"
                                  />
                                )}
                              </button>

                            </>
                          )}
                          
                        </div>
                      </div>
                  </div>
                 
                </div>
              </div>
              <div className="overflow-y-auto">
                <Table
                  menu="angel"
                  sub_type_master_id={
                    Constants.subCategoryIds.pe_angel_invesments_id
                  }
                />
              </div>
              {/* </div> */}
            </section>

          </main>
        </div>
      </div>
    </Layout>
  );
}

export default AngelInvestment;
